<template>
	<div class="file-history">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Uploaded At</th>
                    <th>Uploaded By</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="version in history" :key="version.id">
                    <td>{{version.name}}</td>
                    <td>{{version.created_at}}</td>
                    <td>{{version.user.name}}</td>
                    <td><a class="btn btn-primary btn-sm" :href="'/api/documents/file/' + version.id + '/download'" target="_blank">Download</a></td>
                </tr>
            </tbody>
        </table>
	</div>
</template>

<script>
	export default {
        props: { file: Object },

        computed: {
            history(){
                let fileHistory = [];
                let hasHistory = true;
                let currentFile = this.file;
                while(hasHistory){
                    fileHistory.push(currentFile);
                    if(currentFile.history.length > 0){
                        currentFile = currentFile.history[0];
                    } else {
                        hasHistory = false;
                    }
                }

                return fileHistory;
            }
        }
	}
</script>
